import { PropsWithChildren } from 'react';

import { ChakraBox, ChakraTooltip } from '@equip.health/ui';

import { NotificationStatus } from '~/lib/constants/notifications.constants';

const TOP_LEVEL_ID = 'custom-tooltip';

interface NotificationTooltipProps extends PropsWithChildren {
  isRead: boolean;
  onMarkHandler: (
    event: React.MouseEvent<HTMLElement>,
    status: NotificationStatus,
  ) => void;
}

const NotificationTooltip = ({
  isRead,
  onMarkHandler,
  children,
}: NotificationTooltipProps) => {
  return (
    <ChakraTooltip
      id={`${TOP_LEVEL_ID}__${isRead ? 'unread' : 'read'}`}
      label={`Mark as ${isRead ? 'unread' : 'read'}`}
    >
      <ChakraBox
        _groupHover={{ display: 'block !important' }}
        onClick={(e: React.MouseEvent<HTMLElement>) =>
          onMarkHandler(
            e,
            isRead ? NotificationStatus.UNREAD : NotificationStatus.READ,
          )
        }
        style={{ display: 'none' }}
      >
        {children}
      </ChakraBox>
    </ChakraTooltip>
  );
};

export default NotificationTooltip;
